import React from 'react'

import ReembolsoComercio from './components/ReembolsoComercio'
import { RCProvider } from './context/reembolsoComercio.context'

const ReembolsoComercioRaizen = () => {
  return (
    <RCProvider>
        <ReembolsoComercio/>
        </RCProvider>
  )
}

export default ReembolsoComercioRaizen